function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var e = {
  accessToken: "access_token"
},
    t = ["orderingsDirection"],
    a = function a(_a2, r, n) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var s = new URL("".concat(_a2, "/documents/search"));

  if (s.searchParams.set("ref", r), n) {
    "string" == typeof n && (n = [n]);

    var _iterator = _createForOfIteratorHelper(n),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _e = _step.value;
        s.searchParams.append("q", "[".concat(_e, "]"));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  for (var _a in o) {
    if (t.includes(_a)) continue;

    var _r = _a in e ? e[_a] : _a;

    var _n = o[_a];

    switch (_r) {
      case "orderings":
        _n = Array.isArray(_n) ? _n.join(",") : _n, "desc" === o.orderingsDirection && (_n = "".concat(_n, " desc")), _n = "[".concat(_n, "]");
    }

    null != _n && s.searchParams.set(_r, Array.isArray(_n) ? _n.join(",") : _n.toString());
  }

  return s.toString();
},
    r = function r(e, t) {
  var a = new URL(e);
  return t && a.searchParams.set("access_token", t), a.toString();
},
    n = function n(e) {
  return "https://".concat(e, ".cdn.prismic.io/api/v2");
},
    o = function o(e) {
  return Array.isArray(e) ? "[".concat(e.map(o).join(", "), "]") : "string" == typeof e ? "\"".concat(e, "\"") : e instanceof Date ? "".concat(e.getTime()) : "".concat(e);
},
    s = function s(e) {
  return function (t) {
    return "[".concat(e, "(").concat(t, ")]");
  };
},
    i = function i(e) {
  return function (t) {
    for (var _len = arguments.length, a = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      a[_key - 1] = arguments[_key];
    }

    return "[".concat(e, "(").concat(t).concat(a.length ? ", " : "").concat(a.map(o).join(", "), ")]");
  };
};

var d = {
  __proto__: null,
  at: i("at"),
  not: i("not"),
  any: i("any"),
  in: i("in"),
  fulltext: i("fulltext"),
  has: s("has"),
  missing: s("missing"),
  similar: function similar() {
    for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      e[_key2] = arguments[_key2];
    }

    return "[similar(".concat(e.map(o).join(", "), ")]");
  },
  geopointNear: i("geopoint.near"),
  numberLessThan: i("number.lt"),
  numberGreaterThan: i("number.gt"),
  numberInRange: i("number.inRange"),
  dateAfter: i("date.after"),
  dateBefore: i("date.before"),
  dateBetween: i("date.between"),
  dateDayOfMonth: i("date.day-of-month"),
  dateDayOfMonthAfter: i("date.day-of-month-after"),
  dateDayOfMonthBefore: i("date.day-of-month-before"),
  dateDayOfWeek: i("date.day-of-week"),
  dateDayOfWeekAfter: i("date.day-of-week-after"),
  dateDayOfWeekBefore: i("date.day-of-week-before"),
  dateMonth: i("date.month"),
  dateMonthAfter: i("date.month-after"),
  dateMonthBefore: i("date.month-before"),
  dateYear: i("date.year"),
  dateHour: i("date.hour"),
  dateHourAfter: i("date.hour-after"),
  dateHourBefore: i("date.hour-before")
},
    f = {
  __proto__: null,
  preview: "io.prismic.preview"
},
    c = {
  __proto__: null
};
export { c as Response, a as buildQueryURL, r as buildRepositoryURL, f as cookie, n as defaultEndpoint, d as predicate };